import React from 'react';
import { FormattedMessage } from 'react-intl';

import MessageWithLink from '../Components/MessageWithLink/MessageWithLink';

const getErrorTranslation = (messages, translationKey) =>
  Object.keys(messages).reduce((message, objectKey) => {
    if (messages[objectKey].id === translationKey) {
      if (
        translationKey === 'LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_UNAVAILABLE_ERROR'
      ) {
        return (
          <MessageWithLink
            message={messages[objectKey]}
            linkMessage={messages.newEmailUnavailableErrorLink}
            href={'/'}
          />
        );
      }

      return <FormattedMessage {...messages[objectKey]} />;
    }

    return message;
  }, null) || <FormattedMessage {...messages.genericError} />;

export default getErrorTranslation;
